import script from "./kfInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./kfInfoList.vue?vue&type=script&setup=true&lang=js"

import "./kfInfoList.vue?vue&type=style&index=0&id=24730aaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24730aaa"]])

export default __exports__